// relative-time.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';
import { formatDistanceToNow } from 'date-fns';
import { es } from 'date-fns/locale';

@Pipe({
  name: 'relativeTime',
  standalone: true
})
export class RelativeTimePipe implements PipeTransform {
  transform(value: Date | string | number | null | undefined): string {
    if (!value) return '';
    return formatDistanceToNow(new Date(value), {
      addSuffix: false,
      locale: es           // «hace 2 segundos», «hace 1 hora», etc.
    });
  }
}
